import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum InvoiceMainSearchFields {
	invoiceId = 'InvoiceId'
}

export enum InvoiceFilterFields {
	dateFrom = 'dateFrom',
	dateTo = 'dateTo',
	serviceSite = 'serviceSite',
	cityName = 'cityName',
	state = 'state',
	includeUnpaid = 'isUnpaid'
}

export declare namespace CustomerInvoice {
	interface Basic {
		invoiceId: number
		customer: Entity
		invoiceDate: string
		dueDate: string
		daysPastDue: number
		total: InvoiceTotal
		documentName: BasicString
		reportId: BasicNumber
	}

	namespace Search {
		interface Config {
			[InvoiceMainSearchFields.invoiceId]: ConfigItem<string>
		}

		type Result = string[]
	}

	namespace Filter {
		interface Config {
			[InvoiceFilterFields.dateFrom]: ConfigFilterItem<string, null>
			[InvoiceFilterFields.dateTo]: ConfigFilterItem<string, null>
			[InvoiceFilterFields.serviceSite]: ConfigFilterItem<string, string>
			[InvoiceFilterFields.state]: ConfigFilterItem<string, string>
			[InvoiceFilterFields.includeUnpaid]: ConfigFilterItem<string, boolean>
		}
	}

	interface InvoiceTotal {
		total: number
		currencyCode: string
	}
}

export interface State {
	id: Key
	stateName: string
	stateAbbreviation: string
	countryCode: string
}
